import React, {Component} from "react";
import {Button, Col, Form, Icon, Row, Upload} from "antd";
import PropTypes from "prop-types";

// import {sanitizeFieldName} from "../../util/methods";

class UploadFile extends Component {

  state = {
    uploadFile: true,
    count: 1,
    fileList: [],
    file: null,
    showUploadList: false,
  };

  handleChange = info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
  };

  handleDeleteFile(e) {
    this.setState({uploadFile: true})
  }

  getExistingFileComponent() {
    const {data} = this.props;
    return <Upload.Dragger style={{cursor: 'default'}} disabled={true}>
      <Row type="flex" justify="space-between">
        <Col span={16} style={{display: 'inline-flex', alignItems: 'center', fontSize: '16px'}}><a target="_blank" href={data.file.path}><Icon style={{paddingRight: '10px'}} type="file-pdf" /><span style={{}}>{data.file.name}</span></a></Col>
        <Col span={8}><Button type="danger" onClick={() => { this.handleDeleteFile() }}>Delete Existing File</Button></Col>
      </Row>
    </Upload.Dragger>
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.data && nextProps.data.file && this.state.count) {
      this.setState({uploadFile: false, count: 0});
    }
    if(nextProps.showUploadList === false) {
      this.setState({showUploadList: false})
    }
  }

  customUpload = file => {
    this.setState(state => ({
      fileList: [...state.fileList, file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  render() {
    const {data, form} = this.props;
    const {getFieldDecorator} = form;
    return (
      <Form.Item key={'files'} label="Upload File">
        {getFieldDecorator('files', {
          rules: [{required: true , message: `File is required!`}],
          initialValue: (data && data['file']) ? data['file'] : []
        })(
           !this.state.uploadFile ? this.getExistingFileComponent() : <Upload.Dragger name="files" onChange={this.handleChange} showUploadList={this.state.showUploadList} beforeUpload={this.customUpload} fileList={this.state.fileList}>
            <p className="ant-upload-drag-icon">
              <Icon type="inbox" />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to Upload</p>
            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
          </Upload.Dragger>
        )}

      </Form.Item>
    )
  }
};

export default UploadFile;
UploadFile.defaultProps = {};

UploadFile.propTypes = {
  item: PropTypes.object
};
